
import { z } from "zod";

export const ProjectChecklistSubmissionStatusValues = ["DRAFT", "SUBMITTED", "APPROVED", "REJECTED"] as const;
export const ProjectChecklistSubmissionStatusSchema = /* @__PURE__ */ z.enum(ProjectChecklistSubmissionStatusValues);
export const ProjectChecklistSubmissionStatus: (typeof ProjectChecklistSubmissionStatusSchema)["enum"] = { "DRAFT": "DRAFT", "SUBMITTED": "SUBMITTED", "APPROVED": "APPROVED", "REJECTED": "REJECTED" };
export type ProjectChecklistSubmissionStatus = (typeof ProjectChecklistSubmissionStatusValues)[number];
